module.exports = "/_next/static/images/success-plus-graph-6cd16c79adfc30c4c85925ed50fef2b3.png";